import { Form, FormItemProps, InputNumber } from 'antd';
import { FC, useState } from 'react';
import './styles.scss';

interface FormItemNumberPropsType extends FormItemProps {
  label: React.ReactNode;
  value?: string | number;
  description?: string;
  name: string;
}

const DEFAULT_WIDTH_INPUT_NUMBER = 100;

const FormItemNumber: FC<FormItemNumberPropsType> = (props) => {
  const { label, description, name } = props;
  const [inputWidth, setInputWidth] = useState<number>(DEFAULT_WIDTH_INPUT_NUMBER);

  /**
   * Handle case when user type a number into input
   * If number is too long, auto calculate width of input
   * 6 is pixel of each number
   * @param v value of input number
   */
  const onChange = (v: number | null) => {
    if (!v) {
      setInputWidth(DEFAULT_WIDTH_INPUT_NUMBER);
      return;
    }
    const comma = getAmountComma(v);
    setInputWidth(DEFAULT_WIDTH_INPUT_NUMBER + (v.toString().length + comma) * 6);
  };

  /**
   * @param amount input number
   * @returns number amount comma with input number parameter
   * example 900000000000 => 3
   */
  const getAmountComma = (number: number) => {
    const amountString = number.toString();
    const amountLength = amountString.length;
    const comma = Math.floor(amountLength / 3);
    if (amountLength % 3 === 0) return comma - 1;
    return comma;
  };

  return (
    <Form.Item
      {...props}
      name={name}
      tooltip={description}
      className="form__item-number"
      label={
        <div className="item-number__label">
          <span>{label}</span>
        </div>
      }
    >
      <InputNumber
        formatter={(v) => {
          if (!v) return '';
          return new Intl.NumberFormat('en-us').format(v);
        }}
        onChange={onChange}
        min={0}
        maxLength={12}
        style={{ width: inputWidth, maxWidth: '100%' }}
      />
    </Form.Item>
  );
};

export default FormItemNumber;
